import _ from 'lodash';
import {
  ClipboardDocumentCheckIcon,
  EnvelopeIcon,
  UsersIcon,
  FlagIcon,
  BanknotesIcon,
  DocumentDuplicateIcon,
  QuestionMarkCircleIcon
} from '@heroicons/react/24/outline';

export default function getNavigationLinks(network, currentUser) {
  return _.remove([
    { name: 'Team', icon: UsersIcon, href: `/settings/team`, matches: [`/settings/team`]  },
    { name: 'Screening', icon: ClipboardDocumentCheckIcon, href: `/settings/screening` },
    { name: 'Training', icon: ClipboardDocumentCheckIcon, href: `/settings/training` },
    { name: 'Banner', icon: FlagIcon, href: `/settings/banner` },
    { name: 'Grants', icon: BanknotesIcon, href: `/settings/grants` },
    { name: 'Resources', icon: DocumentDuplicateIcon, href: `/settings/resources` },
    { name: 'Support Questions', icon: QuestionMarkCircleIcon, href: `/settings/support-questions` }
  ]);
};
